import api from "../utils/axios";

export const getProducts = async ({
  page = 1,
  sort = "",
  brands = [],
  brand = "",
  attributeValues = [],
  category = "",
  groups = "",
  onlyAmazing = false,
  minPrice = "",
  maxPrice = "",
  onlyAvailable = false,
  onlyDiscounted = false,
  onlyGiftProducts = false,

  // NEW
  menuCategory = "",
  menuGroups = [],
}) => {
  const params = {
    page,
    sort,

    brands: brands.join(","),
    attributeValues:
      attributeValues.length > 0 ? attributeValues.join(",") : undefined,
    amazing: onlyAmazing ? 1 : 0,

    minPrice,
    maxPrice,

    onlyAvailable,
    onlyDiscounted,
    onlyGiftProducts,
  };

  if (brand) {
    params.brand = brand;
  }

  /*
  |--------------------------------------------------------------------------
  | Menu Level 1
  | products?c=14
  |--------------------------------------------------------------------------
  */
  if (menuCategory) {
    params.c = menuCategory;
  }

  /*
  |--------------------------------------------------------------------------
  | Menu Level 2 / 3
  | products?g=165,206,207
  |--------------------------------------------------------------------------
  */
  if (menuGroups.length > 0) {
    params.g = menuGroups.join(",");
  }

   console.log("PRODUCT PARAMS:", params);

  const { data } = await api.get(`/getAllProducts`, {
    params,
  });

  return data;
};
